import React, { useEffect } from 'react';
import './TechStackSection.css';
import { FaJava, FaJs, FaPhp, FaReact, FaDocker, FaPython, FaDatabase } from 'react-icons/fa';
import { SiJquery, SiKubernetes, SiSpringboot, SiC } from 'react-icons/si';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { techStackOrder } from '../data/techStack';
import { useLanguage } from '../hooks/useLanguage';

const icons = {
  java: <FaJava size={28} />,
  javascript: <FaJs size={28} />,
  php: <FaPhp size={28} />,
  react: <FaReact size={28} />,
  jquery: <SiJquery size={28} />,
  docker: <FaDocker size={28} />,
  kubernetes: <SiKubernetes size={28} />,
  python: <FaPython size={28} />,
  sql: <FaDatabase size={28} />,
  springboot: <SiSpringboot size={28} />,
  c: <SiC size={28} />,
};

const TechStackSection = () => {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="tech-stack" id="tech" data-aos="fade-up">
      <div className="tech-stack-content">
        <h2 className="section-heading" data-aos="fade-up">{t.techStack.title}</h2>
        <p className="section-lead" data-aos="fade-up" data-aos-delay="100">
          {t.techStack.intro}
        </p>
        <ul className="tech-list">
          {techStackOrder.map((id, index) => (
            <li
              key={id}
              className="tech-item"
              data-aos="fade-up"
              data-aos-delay={index * 100 + 200}
            >
              <span className="tech-icon">{icons[id]}</span>
              <span className="tech-name">{t.techNames[id]}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TechStackSection;
